import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import {SearchBranchRequest, SearchBranchResponse, DeleteBranchRequest, DeleteBranchResponse,
        PersistBranchResponse, PersistBranchRequest, CloneBranchRequest, CloneBranchResponse, GetBranchRequest, GetBranchResponse, ChangeActivationStateRequest, ChangeActivationStateResponse } from "../../models/manage/branches.models";
import { BranchesRoutes } from "../../constants/branches/branches.constants";

@autoinject()
export class ManageBranchesClientService {

    constructor(private requestClient: RequestClientService) {
    }

    getAllBranches(request: SearchBranchRequest): Promise<SearchBranchResponse> {
        return this.requestClient.get<SearchBranchResponse>(BranchesRoutes.GetBranches, request);
    }

    getBranch(request: GetBranchRequest): Promise<GetBranchResponse> {
        return this.requestClient.get<GetBranchResponse>(BranchesRoutes.GetBranch, request);
    }

    deleteBranch(request: DeleteBranchRequest): Promise<DeleteBranchResponse> {
        return this.requestClient.post<DeleteBranchResponse>(BranchesRoutes.DeleteBranch, {}, request);
    }

    save(request: PersistBranchRequest): Promise<PersistBranchResponse> {
        return this.requestClient.post<PersistBranchResponse>(BranchesRoutes.SaveBranch, {}, request);
    }

    clone(request: CloneBranchRequest): Promise<CloneBranchResponse> {
        return this.requestClient.post<CloneBranchResponse>(BranchesRoutes.CloneBranch, {}, request);
    }

    changeBranchActivationState(request: ChangeActivationStateRequest): Promise<ChangeActivationStateResponse> {
        return this.requestClient.post<ChangeActivationStateResponse>(BranchesRoutes.ChangeBranchActivationState, {}, request);
    }
}
